import { lazy } from "react";
import Loadable from "../../components/Loadable";
import { ATTENDANCE } from "../../utils/constant";

const MarkAttendance = Loadable(lazy(() => import("./MarkAttendance")));
const StaffAttendance = Loadable(lazy(() => import("./StaffAttendance")));
const attendanceRoute = [
  {
    path: '/attendance/mark',
    element: <MarkAttendance />,
    permission: ATTENDANCE,
  },
  {
    path :"/attendance/staff-attendance",
    element : <StaffAttendance/>,
    permission: ATTENDANCE,
  },
//   {
//     path :"/leave/pendingRequest",
//     element : <PendingLeaveRequest/>,
//     permission: PENDING_LEAVE_REQUEST,
//   }
];

export default attendanceRoute;